/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { SDKOptions } from "./config.js";

export interface Env {
  GOOGLE_GENAI_API_KEY?: string | undefined;
  GOOGLE_GENAI_ACCESS_TOKEN?: string | undefined;

  /**
   * Sets the api_version parameter for all supported operations
   */
  GOOGLE_GENAI_API_VERSION?: string | undefined;

  /**
   * Sets the api_revision parameter for all supported operations
   */
  GOOGLE_GENAI_API_REVISION?: string | undefined;

  /**
   * Sets the user_project parameter for all supported operations
   */
  GOOGLE_GENAI_USER_PROJECT?: string | undefined;

  GOOGLE_GENAI_DEBUG?: boolean | undefined;
}

/**
 * Checks for the existence of the Deno global object to determine the environment.
 * @returns {boolean} True if the runtime is Deno, false otherwise.
 */
function isDeno() {
  if ("Deno" in globalThis) {
    return true;
  }

  return false;
}

let envMemo: Env | undefined = undefined;
/**
 * Reads and validates environment variables.
 */
export function env(): Env {
  if (envMemo) {
    return envMemo;
  }

  const globals = globalThis as {
    Deno?: { env?: { toObject?: () => Record<string, string | undefined> } };
    process?: { env?: Record<string, string | undefined> };
  };

  let envObject: Record<string, unknown> = {};
  if (isDeno()) {
    envObject = globals.Deno?.env?.toObject?.() ?? {};
  } else {
    envObject = globals.process?.env ?? {};
  }

  envMemo = envObject as unknown as Env;
  return envMemo;
}

/**
 * Clears the cached env object. Useful for testing with a fresh environment.
 */
export function resetEnv() {
  envMemo = undefined;
}

/**
 * Populates global parameters with environment variables.
 */
export function fillGlobals(options: SDKOptions): SDKOptions {
  const clone = { ...options };

  const envVars = env();

  if (typeof envVars.GOOGLE_GENAI_API_VERSION !== "undefined") {
    clone.api_version ??= envVars.GOOGLE_GENAI_API_VERSION;
  }
  if (typeof envVars.GOOGLE_GENAI_API_REVISION !== "undefined") {
    clone.api_revision ??= envVars.GOOGLE_GENAI_API_REVISION;
  }
  if (typeof envVars.GOOGLE_GENAI_USER_PROJECT !== "undefined") {
    clone.user_project ??= envVars.GOOGLE_GENAI_USER_PROJECT;
  }

  return clone;
}
